import { useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { usersApi, User, ResetPasswordDto } from '../../api/usersApi';

interface ResetPasswordModalProps {
  open: boolean;
  user: User | null;
  onSuccess: () => void;
  onCancel: () => void;
}

const ResetPasswordModal = ({ open, user, onSuccess, onCancel }: ResetPasswordModalProps) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!user) return;

    try {
      const values = await form.validateFields();
      setLoading(true);

      const data: ResetPasswordDto = {
        newPassword: values.newPassword,
      };

      await usersApi.resetPassword(user.id, data);
      message.success('Parola a fost resetată cu succes');
      form.resetFields();
      onSuccess();
    } catch (error: any) {
      if (error.response?.data?.message) {
        message.error(error.response.data.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Resetare Parolă"
      open={open}
      onOk={handleSubmit}
      onCancel={onCancel}
      confirmLoading={loading}
      okText="Resetează"
      cancelText="Anulează"
      width={500}
    >
      {user && (
        <>
          <p>
            Resetare parolă pentru: <strong>{user.firstName} {user.lastName}</strong>
          </p>
          <Form form={form} layout="vertical" autoComplete="off">
            <Form.Item
              label="Parolă Nouă"
              name="newPassword"
              rules={[
                { required: true, message: 'Parola nouă este obligatorie' },
                { min: 8, message: 'Parola trebuie să aibă minim 8 caractere' },
              ]}
              extra="Minim 8 caractere, inclusiv majuscule, minuscule, cifre și caractere speciale"
            >
              <Input.Password placeholder="Introduceți parola nouă" />
            </Form.Item>

            <Form.Item
              label="Confirmă Parola"
              name="confirmPassword"
              dependencies={['newPassword']}
              rules={[
                { required: true, message: 'Confirmarea parolei este obligatorie' },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('newPassword') === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('Parolele nu se potrivesc'));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Confirmați parola nouă" />
            </Form.Item>
          </Form>
        </>
      )}
    </Modal>
  );
};

export default ResetPasswordModal;
